<template>
    <div class="gty-tag" :id="defaultContainerId">
        <a :id="tooltipId">
            <span class="det_text fw-400">随机房须知</span>
            <img class="det_icon" src="https://resource.rcclchina.com.cn/tui2/info/webhao.png">
        </a>
        <b-tooltip :target="tooltipId" :container="containerId" triggers="hover" :placement="'right'"
        :boundary="'window'">
            <div>
                温馨提醒：如预订随机舱房，请注意：
                <br/>1. 请您完成全款支付后，于出行前7天在个人中心订单查询页面确认舱房号。
                <br/>2. 随机舱房房间号为系统随机分配，可能无法满足楼层以及房间位置的指定需求。
                <br>3. 部分随机阳台房/银卡套房为遮挡房型，阳台外侧悬挂救生艇，或阳台有部分面积被船体设施占用，阳台视线会有遮挡。
            </div>
        </b-tooltip>
    </div>
</template>

<script>
export default {
    name: "GtyTag",
    props: {
        index: {
            type: String,
            default () {
                return ""
            }
        },
        targetContainer: {
            type: String
        }
    },
    computed: {
         tooltipId () {
            if (!this.index || this.index == '') {
                return 'gtyTag_tooltip_' + (new Date()).getTime() + Math.random(1000)
            }
            return 'gtyTag_tooltip_' +this.index
        },
        containerId () {
            if (this.targetContainer && this.targetContainer.length > 0) {
                return this.targetContainer
            }
            return this.defaultContainerId
        },
        defaultContainerId () {
            if (!this.index || this.index == '') {
                return 'gtyTag_container_' + (new Date()).getTime() + Math.random(1000)
            }
            return 'gtyTag_container_' +this.index
        }
    }
}
</script>

<style lang="less" scoped>
.gty-tag {
    display: inline-block;
    cursor: pointer;
}
.det_text {
    color: #006ab9;
}
.det_icon {
    width: 16px;
    margin-top: -2px;
    margin-left: 5px;
}
</style>